import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';
import { GasPriceList } from '../gas-price-list/GasPriceList';
import type { IGasPriceModel, ITransferFees, ICryptoCurrency, IGetlocalizedMessage, INetworkDescriptionModel } from '../../interfaces/gas-price.model';
import { getGasPriceSkeletonWidth, getGasPriceSkeletonHeight } from '../../helpers/skeleton-helpers';

interface GasPriceSectionProps {
  gasPriceData: IGasPriceModel | null;
  gasPriceLoading: boolean;
  isTimerEnd: boolean;
  isTablet: boolean;
  isMobile: boolean;
  timer: string;
  localizations: Map<string, string>;
  localizedMessage: IGetlocalizedMessage;
  tokenPrice: ITransferFees | null;
  selectedNetwork: ICryptoCurrency | undefined;
  networkDescription: INetworkDescriptionModel | null;
}
export function GasPriceSection({
  gasPriceData,
  gasPriceLoading,
  selectedNetwork,
  isTimerEnd,
  isTablet,
  isMobile,
  timer,
  localizations,
  localizedMessage,
  tokenPrice,
  networkDescription,
}: GasPriceSectionProps) {
  const [searchParams] = useSearchParams();
  const [networkName, setNetworkName] = useState(gasPriceData?.name ?? '');

  useEffect(() => {
    const networkFromUrl = searchParams.get('networkId');
    if (networkFromUrl != null) setNetworkName(networkFromUrl);
  }, [searchParams, gasPriceData]);
  return (
    <>
      <div className="calculator__content--left-side">
        {gasPriceLoading || !isTimerEnd ? (
          <Skeleton height={60} />
        ) : (
          <h3>
            {localizedMessage('calculator__description-part-1')} <span className="calculator__content-gradien-word">{networkName}</span> {localizedMessage('calculator__description-part-2')}
          </h3>
        )}
        {gasPriceLoading || !isTimerEnd ? <Skeleton height={isTablet || isMobile ? 100 : 220} /> : <span>{networkDescription?.description}</span>}
      </div>
      <div className="calculator__content--right-side">
        {gasPriceLoading || !isTimerEnd ? (
          <Skeleton height={20} width={isTablet || isMobile ? ' ' : 200} />
        ) : (
          timer !== '' &&
          isTimerEnd && (
            <div className="calculator__content--gas-price-list-timer">
              {localizedMessage('calculator__text-update')}&nbsp;
              <span className="calculator__content--gas-price-list-timer-link">{timer}</span>
            </div>
          )
        )}
        <div className="calculator__content--gas-price-container">
          {gasPriceLoading || !isTimerEnd ? (
            <Skeleton
              count={3}
              containerClassName="skeleton__gas-price-container"
              inline
              width={getGasPriceSkeletonWidth(isTablet, isMobile)}
              height={getGasPriceSkeletonHeight(isTablet, isMobile)}
              borderRadius={12}
            />
          ) : (
            <GasPriceList data={gasPriceData} localizations={localizations} loading={gasPriceLoading} tokenPrice={tokenPrice} selectedNetwork={selectedNetwork} />
          )}
        </div>
      </div>
    </>
  );
}
